export interface UnitMapUnit {
  id: string;
  name: string;
  type: string;
  districtId: string;
  districtName: string;
  charterOrg: string | null;
  address: string | null;
  cityState: string | null;
  zip: string | null;
  latitude: number | null;
  longitude: number | null;
  paidYouth: number | null;
  membershipSource: 'recharter' | 'charterOrg' | null;
  membershipDate: string | null;
}

export interface UnitMapGroup {
  zip: string;
  latitude: number;
  longitude: number;
  units: UnitMapUnit[];
  districtIds: string[];
  knownYouth: number | null;
}

export const DISTRICT_COLORS = [
  '#2563eb', '#dc2626', '#059669', '#9333ea', '#d97706', '#0891b2',
  '#db2777', '#4f46e5', '#65a30d', '#b45309', '#0f766e', '#7c3aed',
];
export const MIXED_DISTRICT_COLOR = '#64748b';

export function groupUnitMapUnits(units: readonly UnitMapUnit[]): UnitMapGroup[] {
  const grouped = new Map<string, UnitMapUnit[]>();
  for (const unit of units) {
    if (!unit.zip || unit.latitude === null || unit.longitude === null) continue;
    grouped.set(unit.zip, [...(grouped.get(unit.zip) ?? []), unit]);
  }
  return [...grouped.entries()].sort(([left], [right]) => left.localeCompare(right)).map(([zip, values]) => {
    const known = values.flatMap((unit) => unit.paidYouth === null ? [] : [unit.paidYouth]);
    return {
      zip,
      latitude: values[0].latitude!,
      longitude: values[0].longitude!,
      units: [...values].sort((left, right) => left.name.localeCompare(right.name)),
      districtIds: [...new Set(values.map((unit) => unit.districtId))].sort(),
      knownYouth: known.length ? known.reduce((sum, value) => sum + value, 0) : null,
    };
  });
}

export function districtColorMap(districtIds: readonly string[]): Map<string, string> {
  return new Map([...new Set(districtIds)].sort().map((id, index) => [id, DISTRICT_COLORS[index % DISTRICT_COLORS.length]]));
}

export function markerColor(group: UnitMapGroup, colors: ReadonlyMap<string, string>): string {
  return group.districtIds.length === 1 ? (colors.get(group.districtIds[0]) ?? MIXED_DISTRICT_COLOR) : MIXED_DISTRICT_COLOR;
}

export function unitTypeLabel(type: string): string {
  const labels: Record<string, string> = {
    pack: 'Pack', troop: 'Troop', crew: 'Crew', ship: 'Ship', post: 'Post', club: 'Club', other: 'Other',
  };
  return labels[type.toLowerCase()] ?? type;
}
